import { render } from "./hotspot-section.vue?vue&type=template&id=55ab6912"
import script from "./hotspot-section.vue?vue&type=script&lang=js"
export * from "./hotspot-section.vue?vue&type=script&lang=js"

import "./hotspot-section.vue?vue&type=style&index=0&id=55ab6912&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__